const spinkitSpinners = {
    'three-bounce': { className: 'sk-three-bounce', divCount: 2 },
  };
  
  module.exports = {
    spinkitSpinners,
    allSpinners: {
      ...spinkitSpinners,
    },
  };


// WEBPACK FOOTER //
// ./src/components/Spinner/spinners.js